// Prints one person's vacation / overtime report for a year in its own
// window, in the same plain bordered style as printTable: the totals
// (incl. what's still left after the planned days), days and overtime per
// month, every absence and every overtime / note entry.
//
// labels: translated strings, see VacationUserStats for the keys.

const esc = (v) =>
  String(v ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

const table = (headers, rows, numCols = []) => {
  const td = (tag, v, i) =>
    `<${tag}${numCols.includes(i) ? ' class="num"' : ''}>${esc(v === '' || v == null ? '-' : v)}</${tag}>`;
  return `<table>
  <thead><tr>${headers.map((h, i) => td('th', h, i)).join('')}</tr></thead>
  <tbody>${rows.map((r) => `<tr>${r.map((v, i) => td('td', v, i)).join('')}</tr>`).join('')}</tbody>
</table>`;
};

export const printVacationReport = ({ title, totals, months, entries, overtime, labels }) => {
  const win = window.open('', '_blank');
  if (!win) return;

  const section = (heading, html) => `<h2>${esc(heading)}</h2>${html}`;

  win.document.write(`<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<title>${esc(title)}</title>
<style>
  body { font-family: Calibri, Arial, sans-serif; font-size: 10pt; color: #000; margin: 20px; }
  h1 { font-size: 14pt; margin: 0 0 4px; }
  h2 { font-size: 11pt; margin: 16px 0 6px; }
  p { margin: 0 0 12px; font-size: 9pt; }
  table { border-collapse: collapse; width: 100%; }
  th, td { border: 1px solid #000; padding: 3px 5px; text-align: left; vertical-align: top; }
  th { font-weight: bold; }
  .num { text-align: right; white-space: nowrap; }
  .totals td:first-child { width: 45%; }
  .totals tr.strong td { font-weight: bold; }
  tr { page-break-inside: avoid; }
  thead { display: table-header-group; }
  @page { margin: 12mm; }
</style>
</head>
<body>
<h1>${esc(title)}</h1>
<p>${esc(new Date().toLocaleDateString('de-CH'))}</p>
<table class="totals"><tbody>${totals
    .map(
      ([label, value, strong]) =>
        `<tr${strong ? ' class="strong"' : ''}><td>${esc(label)}</td><td class="num">${esc(value)}</td></tr>`,
    )
    .join('')}</tbody></table>
${section(labels.perMonth, table(months.headers, months.rows, months.headers.map((_, i) => i).slice(1)))}
${section(labels.entries, entries.rows.length ? table(entries.headers, entries.rows, [3]) : `<p>${esc(labels.none)}</p>`)}
${section(labels.overtime, overtime.rows.length ? table(overtime.headers, overtime.rows, [1]) : `<p>${esc(labels.none)}</p>`)}
</body>
</html>`);
  win.document.close();
  win.focus();
  win.print();
};

export default printVacationReport;
